module.exports = __webpack_public_path__ + "media/apps/mitch-android-3-f11cf8dc.png";